import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { API_CONFIG_TOKEN, ApiEndpoints } from './api-config';


@Injectable({
  providedIn: 'root'
})
export class UserModuleService {

  private baseUrl = environment.apiUrl

  constructor(
    private http: HttpClient,
    @Inject(API_CONFIG_TOKEN) private apiConfig: ApiEndpoints
  ) { }

  login(payload: any): Observable<any> {
    const url = `${this.baseUrl}${this.apiConfig['WebAuth']['Login']}`;
    return this.http.post(url, payload, { observe: 'response' });
  }


  getUserById(UserId: any): Observable<any> {
    const params = new HttpParams().set('UserId', UserId)
    const url = `${this.baseUrl}${this.apiConfig['User']['GetUserById']}`;
    return this.http.get(url, { params, observe: 'response' });
  }

  getProfileById(UserId: any): Observable<any> {
    //console.log("UserId",UserId);
    const params = new HttpParams()
      .set('userId', UserId)
    const url = `${this.baseUrl}${this.apiConfig['User']['GetProfileById']}`;
    return this.http.get(url, { params, observe: 'response' });
  }


  updatePassward(payload: any): Observable<any> {
    const url = `${this.baseUrl}${this.apiConfig['WebAuth']['updatePassward']}`;
    return this.http.post(url, payload, { observe: 'response' });
  }




}
